var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"anjian"},[_c('div',{staticClass:"card-right-top"},[(_vm.menuName == 'media_set' )?_c('Card',[_c('PublicPond')],1):_vm._e(),(_vm.menuName == 'client_sea' )?_c('Card',[_c('MareLiberumMenu')],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }